import React, { useState, useEffect, useContext } from "react"
import styles from "./Endoso.module.css"
import GeneralContext from "../../context/GeneralContext"
import * as Funciones from "../../utils/funciones"
import {CODIGO_ENTIDAD_DEFAULT, CODIGO_TIPO_CREDITO_DEFAULT, PRODUCT_ENDOSADO} from "../../utils/constantes"
import btnDelete from "../../img/btneliminar.png"

const Endoso = ({ state, setState,endosoBancarioPreload, product }) => {
    const { state: generalState } = useContext(GeneralContext)

    const [ creditos, setCreditos ] = useState([])
    const [ entidades, setEntidades ] = useState([])
    const [listEndoso, setListEndoso] = useState([]);
    const [inputValues, setInputValues] = useState({});

    useEffect(() => {
        const cargarCombos = () => {
            setCreditos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 62))
            setEntidades(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 61))
        }

        cargarCombos()
    }, [])

    useEffect(() => {

        const filteredListEndoso = listEndoso?.map(({ codigoEntidad, codigoTipoCredito, montoEndosado }) => ({
            codigoEntidad,
            codigoTipoCredito,
            montoEndosado: parseFloat((montoEndosado || '').toString().replace(/[^0-9.-]+/g, '')) || 0
        }));

        setState(prevState => ({
            ...prevState,
            endosoBancario: filteredListEndoso
        }));

        if (Object.keys(inputValues).length === 0) {
            const initialInputValues = listEndoso.reduce((acc, endoso, index) => {
                acc[index] = endoso.descripcion || '';
                return acc;
            }, {});
            setInputValues(initialInputValues);
        }
        
    }, [listEndoso, setState]);

    useEffect(() => {
        if (endosoBancarioPreload) {
            const updatedListEndoso = endosoBancarioPreload.map(endoso => {
                const entidad = entidades.find(ent => ent.codigo === endoso.codigoEntidad);
                return {
                    ...endoso,
                    descripcion: entidad ? entidad.descripcion : ''
                };
            });
            setListEndoso(updatedListEndoso);
        }
    }, [endosoBancarioPreload, entidades]);

    const handleChangeCreditoEndoso = (e, index) => {
        let codigo = e.target.value

        setListEndoso((prevState) => {
            const updatedList = prevState.map((item, i) => {
                if (i === index) {
                    return {
                        ...item,
                        codigoTipoCredito: parseInt(codigo) === 0 ? null : parseInt(codigo),
                    };
                }
                return item;
            });
    
            return updatedList;
        });
    }

    const handleAmountChange = (e, index) => {
        let monto = e.target.value

        setListEndoso((prevState) => {
            const updatedList = prevState.map((item, i) => {
                if (i === index) {
                    return {
                        ...item,
                        montoEndosado: monto || "",
                    };
                }
                return item;
            });
    
            return updatedList;
        });
    }

    const handleAddEndoso = () => {
        const newEndoso = { codigoEntidad: CODIGO_ENTIDAD_DEFAULT, codigoTipoCredito: CODIGO_TIPO_CREDITO_DEFAULT, montoEndosado: '' };
        setListEndoso([...listEndoso, newEndoso]);
      };

    const handleInputChange = (e, index) => {
        const value = e.target.value;
        setInputValues(prevValues => ({
          ...prevValues,
          [index]: value
        }));
    
        const suggestion = entidades.find(item => item.descripcion === value);
        if (suggestion) {
          const updatedListEndoso = listEndoso.map((item, i) =>
            i === index ? 
            { ...item, codigoEntidad: suggestion.codigo } : item
          );
          setListEndoso(updatedListEndoso);
        }
      };
    
      const handleSuggestionSelect = (e, index) => {
        const selectedOption = e.target.value;
        const suggestion = entidades.find(item => item.descripcion === selectedOption);
        if (suggestion) {
          setInputValues(prevValues => ({
            ...prevValues,
            [index]: suggestion.descripcion
          }));
    
          const updatedListEndoso = listEndoso.map((item, i) =>
            i === index ? 
            { ...item, codigoEntidad: suggestion.codigo, descripcion: suggestion.descripcion } : item
          );
          setListEndoso(updatedListEndoso);
        }
      };

    const handleDeleteEndoso = (index) => {
        const updatedList = listEndoso.filter((_, i) => i !== index);
        if (typeof inputValues === 'object' && inputValues) {
            const { [index]: _, ...updatedInputValues } = inputValues;
            setInputValues(updatedInputValues);
        } 
        setListEndoso(updatedList);
    };

    const productEndosado = product.find(p => p.codigoLineaNegocio === PRODUCT_ENDOSADO);
    const currencyEndoso = productEndosado ? productEndosado.simboloMoneda : "";

    return (      
                <div className={styles.container}>
                <div className={styles.containerGrids}>
                <div className={styles.tableContainerHeaders}>
                  <div className={styles.header}>Tipo de crédito</div>
                  <div className={styles.headerEntity}>Entidad Financiera</div>
                  <div className={styles.header}>Monto de crédito</div>
                 <div className={styles.containerButton}>
                  <button className={styles.buttonEndoso} onClick={handleAddEndoso}><span className={styles.textButton}>+</span>Insertar</button></div></div>

                {listEndoso?.map((endoso, index) => (  
                    <div className={styles.tableContainerData} key={index}>
                <div className={styles.data}>
                <select
                    className={styles.creditoEndoso}
                    value={endoso?.codigoTipoCredito || 0}
                    onChange={(e) => handleChangeCreditoEndoso(e, index)}
                >
                    <option value={0}>Seleccione</option>
                    {creditos && creditos.length > 0 && creditos.map(credito => (
                        <option key={credito.id} value={credito.id}>{credito.valor}</option>
                    ))}
                </select>
                </div>
                  <div className={styles.data} key={index}>
                  <input className={styles.entidadEndoso}
              type="text"
              list={`suggestions-${index}`}
              value={inputValues[index] || ''}
              onChange={(e) => handleInputChange(e, index)}
              onBlur={(e) => handleSuggestionSelect(e, index)}
            />
            <datalist id={`suggestions-${index}`}>
              {entidades
                .filter(item =>
                  item.descripcion && item.descripcion.toLowerCase().includes(inputValues[index]?.toLowerCase() || '')
                )
                .map(suggestion => (
                  <option key={suggestion.codigo} value={suggestion.descripcion}>
                    {suggestion.descripcion}
                  </option>
                ))}
            </datalist>
                  </div>

                  <div className={styles.data}>
                    <input type="text" className={styles.montoEndoso}
                     value={`${currencyEndoso} ${Funciones.formatoMonedaEndoso(endoso?.montoEndosado)}` || ''}
                     onChange={(e) => handleAmountChange(e, index)}
                    /> </div>
                    <div className={styles.dataDelete}>
                    <button className={styles.deleteEndoso} onClick={() => handleDeleteEndoso(index)}>
                        <img  src={btnDelete}></img></button> </div>
                </div>))}</div>
                </div>  
    )
}

export default Endoso